import { Injectable } from '@angular/core';
import { SessionAwareMultiStore } from '../../../../shared/stores/session-aware-store';
import { Application } from '../models/application';

@Injectable({ providedIn: 'root' })
export class ApplicationsStore extends SessionAwareMultiStore<Application> {}
